import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "viewer-section" }
const _hoisted_2 = { class: "viewer-header" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = {
  key: 1,
  class: "error"
}
const _hoisted_6 = {
  key: 2,
  class: "json-content"
}
const _hoisted_7 = { class: "file-info-bar" }
const _hoisted_8 = { class: "json-display" }
const _hoisted_9 = { class: "viewer-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", null, "JSON File", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('replace'))),
          class: "btn btn-primary"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "sync" }),
          _cache[2] || (_cache[2] = _createTextVNode(" Replace File ", -1))
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading file..."))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
        : (_ctx.jsonData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, "Size: " + _toDisplayString(_ctx.formatFileSize(_ctx.fileStats?.size || 0)), 1),
                _createElementVNode("span", null, "Modified: " + _toDisplayString(_ctx.formatDate(_ctx.fileStats?.modified)), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("pre", null, [
                  _createElementVNode("code", null, _toDisplayString(JSON.stringify(_ctx.jsonData, null, 2)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args))),
                  class: "btn btn-success"
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "download" }),
                  _cache[4] || (_cache[4] = _createTextVNode(" Download ", -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}